import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Email } from '@material-ui/icons';

export default makeStyles((theme) => ({
    page: {
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vh',
        paddingBottom: theme.spacing(15),
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.25)',
        width: '100%',
    },
    paperHeader: {
        backgroundColor: '#F3F4F8',
        width: '100%',
        height: 124,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        minWidth: '328',
        padding: '0 112px 80px',
        textAlign: 'center',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    link: {
        textDecoration: 'underline',
        color: theme.palette.text.primary,
        fontSize: 12,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    appBarWrapper: {
        flexGrow: 1,
        height: 95,
        display: 'flex',
        alignItems: 'center',
        marginBottom: 45,
    },
    brand: {
        flexGrow: 1,
        '& > a': {
            display: 'inline-block',
        },
    },
    cardHeader: {
        backgroundColor: '#F3F4F8',
    },
    cardHeaderTitle: {
        fontWeight: 700,
        fontSize: 18,
        color: '#313241',
    },
    cardHeaderSubTitle: {
        fontSize: 14,
        maxWidth: 458,
        margin: theme.spacing(2, 'auto', 3),
    },
    cardSubHeader: {
        backgroundColor: 'white',
        textAlign: 'center',
        padding: 10,
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 115,
        '&:last-child': {
            paddingBottom: 263,
        },
    },
    cardContentGrid: {
        maxWidth: 680,
    },
    cardGridTitle: {
        textAlign: 'center',
    },
    cardSteps: {
        display: 'flex',
        alignItems: 'center',
        height: 4,
        maxWidth: 687,
        justifyContent: 'center',
        margin: '10px auto 14px',
        '& > div': {
            width: '33.3333333333%',
            margin: '0 4px',
        },
    },
    popularPlanCard: {
        fontSize: 14,
        fontWeight: 600,
        padding: 15,
        backgroundColor: theme.palette.tertiary.main,
        color: 'white',
    },
    planCard: {
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        padding: theme.spacing(5, 4),
        textAlign: 'center',
    },
    planTitle: {
        fontSize: 28,
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },
    planSubTitle1: {
        fontSize: theme.spacing(2),
        fontWeight: 600,
        maxWidth: 271,
        margin: '0 auto',
    },
    planSubTitle2: {
        fontSize: theme.spacing(2),
        fontWeight: 400,
        margin: `0 auto ${theme.spacing(4)}px`,
        maxWidth: 271,
    },
    planPrice: {
        fontWeight: 600,
        fontSize: 100,
        marginBottom: theme.spacing(1),
        lineHeight: 1,
        '& > sup': {
            fontSize: theme.spacing(4),
            position: 'relative',
            top: -13,
        },
    },
    planBillTitle: {
        fontSize: theme.spacing(2),
        fontWeight: 400,
        margin: `0 auto ${theme.spacing(3)}px`,
        maxWidth: 186,
    },
    planButton: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },
    planCurrencies: {
        marginBottom: 11,
        backgroundColor: theme.palette.tertiary.main,
    },
    planCurrencyButton: {
        color: 'white !important',
        fontWeight: 600,
        fontSize: 14,
    },
}));

export const StyledButton = withStyles((theme) => ({
    root: {
        borderColor: 'white',
        marginLeft: theme.spacing(2),
    },
    label: {
        textTransform: 'capitalize',
        color: 'white',
        fontWeight: 700,
    },
}))(Button);

export const EmailIcon = withStyles(() => ({
    root: {
        width: 82,
        height: 66,
        color: '#F3F4F8',
    },
}))(Email);
